import { Badge } from "@/components/ui/badge"

export default function AgendaEditEventStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Editar un evento</h1>
      </header>
      <p className="text-left text-sm text-muted-foreground">
        Al hacer clic en un evento ya creado en tu agenda, podés editarlo o eliminarlo si lo
        necesitás.
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 2 de 8</span>
      </Badge>
    </section>
  )
}
